import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import ReactPlayer from "react-player";
import axios from "axios";

const Videos = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  const [videos, setVideos] = useState([]);
  const [videosLoading, setVideosLoading] = useState(true);

  useEffect(() => {
    setVideosLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/multimedia/videos/`)
      .then((res) => {
        setVideos(res.data);
      })
      .catch(() => {
        setVideos([]);
      })
      .finally(() => {
        setVideosLoading(false);
      });
  }, [lang]);

  return (
    <div className="row pb-5">
      <div className="col-12">
        <h4 className="fw-bold mb-3">{getContent(content, "Videos", lang)}</h4>
      </div>
      <div className="col-12">
        {videosLoading === true ? (
          "Loading..."
        ) : (
          <div className="row">
            {videos.map((video) => (
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4">
                <ReactPlayer
                  url={process.env.REACT_APP_API_URL + video.src}
                  light={process.env.REACT_APP_API_URL + video.poster}
                  style={{ backgroundColor: "rgba(0, 141, 109, 0.05)" }}
                  controls
                  className="react-player"
                  width="100%"
                  height="250px"
                  config={{
                    youtube: {
                      playerVars: { showinfo: 1 },
                    },
                    facebook: {
                      appId: "12345",
                    },
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Videos;
